<n-panel height="100%">
    <div class="table-layout">
        <div class="table-operation gutter-sm">
            <n-button-group
                [relateTable]="dt"
                [items]="[retryBtn, deleteBtn]">
            </n-button-group>
            <button pButton
                class="icon-btn border"
                style="margin-left: auto;"
                icon="icon-refresh"
                (click)="onRefresh()"
                id="monitor_task_table_click_refresh">
            </button>
        </div>
        <div class="table-container">
            <n-data-table #dt
                [id]="SWITCH.IS_SIMPLE_MODE ? 'simple_monitor_task_table' : 'monitor_task_table'"
                [simpleMode]="SWITCH.IS_SIMPLE_MODE"
                style="height: 100%;"
                [config]="tableConfig"
                [columnDefs]="columnDefs"
                [rest]="dataRest"
                (selectionChange)="onSelectionChange($event)"
                [(selection)]="selectedItems">
                <ng-template nTemplate
                    [meta]="{field: 'taskStatus'}"
                    let-col
                    let-value="value"
                    let-rowIndex="rowIndex"
                    let-task="rowData">
                    <div class="interval-5">
                        <p-progressBar class="progress-bar"
                            [showValue]="false"
                            [value]="task.progress"
                            [color]="str.statusColor[task.taskStatus]">
                        </p-progressBar>
                        <div [nTextTips]="content" style="flex-shrink: 1;">
                            <ng-container [ngTemplateOutlet]="content"></ng-container>
                        </div>
                    </div>
                    <ng-template #content>
                        <span *ngIf="task.taskStatus === taskStatus.running || task.taskStatus === taskStatus.rollbacking">
                            {{task.progress}}%
                        </span>
                        <span class="ml-5" *ngIf="task.taskStatus === taskStatus.particalFailed || task.taskStatus === taskStatus.failed || task.taskStatus === taskStatus.rollbackFailed"
                            class="linkText"
                            (click)="onShowDetail(task)"
                            [innerHTML]="value">
                        </span>
                        <span class="ml-5" *ngIf="!(task.taskStatus === taskStatus.particalFailed || task.taskStatus === taskStatus.failed || task.taskStatus === taskStatus.rollbackFailed)"
                            [innerHTML]="value">
                        </span>
                    </ng-template>
                </ng-template>
            </n-data-table>
        </div>
    </div>

    <app-task-detail *ngIf="!SWITCH.IS_SIMPLE_MODE && detailData"
        [(show)]="showDetail"
        [task]="detailData"
        (onClose)="onDetailClose()">
    </app-task-detail>
</n-panel>

<ng-template #promptTable>
    <n-data-table id="monitor_task_delete_table"
        style="height: 300px;"
        [config]="deleteTableConfig"
        [columnDefs]="deleteTableColumnDefs"
        [data]="promptTableData">
        <ng-template nTemplate
            [meta]="{field: 'taskStatus'}"
            let-col
            let-value="value"
            let-task="rowData">
            <div class="interval-5">
                <svg class="icon">
                    <use [attr.xlink:href]="icon[task.taskStatus]"></use>
                </svg>
                <span [innerHTML]="statusText[task.taskStatus]"></span>
            </div>
        </ng-template>
    </n-data-table>
</ng-template>
